import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import ContactModal from './ContactModal';
import { COMPANY_PHONE_DISPLAY } from '../constants';

const Footer = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    setIsContactModalOpen(true);
  };

  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            {/* Left Section */}
            <div className="footer-section">
              <h3>Sky Harbor Shuttle LLC</h3>
              <p>Professional transportation services in the Pacific Northwest</p>
            </div>

            {/* Middle Section */}
            <div className="footer-section">
              <h3>Contact Info</h3>
              <div className="contact-info">
                <p><FaPhone /> {COMPANY_PHONE_DISPLAY}</p>
                <p><FaEnvelope /> contact@washuttle.com</p>
                <p><FaMapMarkerAlt /> 117 S Maple St<br />Aberdeen, WA 98520</p>
              </div>
            </div>

            {/* Right Section */}
            <div className="footer-section">
              <h3>Quick Links</h3>
              <ul className="footer-links">
                <li><Link to="/services" onClick={scrollToTop}>Services</Link></li>
                <li><Link to="/about" onClick={scrollToTop}>About Us</Link></li>
                <li><Link to="/careers" onClick={scrollToTop}>Careers</Link></li>
                <li><a href="#contact" onClick={handleContactClick}>Contact</a></li>
              </ul>
            </div>
          </div>

          {/* Copyright Section */}
          <div className="copyright">
            <p>&copy; {new Date().getFullYear()} Sky Harbor Shuttle LLC. All rights reserved.</p>
          </div>
        </div>
      </footer>

      <ContactModal 
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
    </>
  );
};

export default Footer; 